<template>
	<section class="auth-errors">
		<p class="auth-errors__header">{{ header }}</p>
		<ul>
			<li v-for="error in errorMessages" class="auth-errors__item bullet-list-item" :key="error">
				{{ error }}
			</li>
		</ul>
	</section>
</template>

<script>
	export default {
		props: {
			errorMessages: Array,
			header: String
		}
	}
</script>

<style lang="scss">
	
</style>